/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { ArgumentTypes, FunctionPlugin } from './FunctionPlugin';
export class DegreesPlugin extends FunctionPlugin {
    degrees(ast, formulaAddress) {
        return this.runFunction(ast.args, formulaAddress, this.metadata('DEGREES'), (arg) => arg * (180 / Math.PI));
    }
}
DegreesPlugin.implementedFunctions = {
    'DEGREES': {
        method: 'degrees',
        parameters: [
            { argumentType: ArgumentTypes.NUMBER }
        ]
    },
};
